import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { dashboardAreaGuard } from './shared/guards/dashboard-area.guard';
import { guestGuard } from './shared/guards/guest.guard';
import { AREA_PATHS, homeArea, storedUser } from './shared/utils/dashboard-access';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
    canActivate: [guestGuard]
  },
  {
    path: 'lateOrders',
    loadChildren: () => import('./late-orders/late-orders.module').then(m => m.LateOrdersModule),
    canActivate: [dashboardAreaGuard('logistics')]
  },
  {
    path: 'lateorders',
    redirectTo: 'lateOrders'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [dashboardAreaGuard('logistics')]
  },
  {
    path: 'widgets',
    loadChildren: () => import('./widgets-page/widgets-page.module').then(m => m.WidgetsPageModule),
    canActivate: [dashboardAreaGuard('logistics')]
  },
  {
    path: 'warehouse',
    loadChildren: () => import('./warehouse/warehouse.module').then(m => m.WarehouseModule),
    canActivate: [dashboardAreaGuard('warehouse')]
  },
  {
    path: 'driver',
    loadChildren: () => import('./driver/driver.module').then(m => m.DriverModule),
    canActivate: [dashboardAreaGuard('logistics')]
  },
  {
    path: '',
    pathMatch: 'full',
    // The user's home dashboard (see dashboard-access.ts); login when there is none.
    redirectTo: () => {
      const home = homeArea(storedUser());
      return home ? AREA_PATHS[home] : '/auth';
    }
  },
  {
    path: '**',
    redirectTo: 'auth'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
